'use client';

import React from 'react';
import { ButtonCta } from '@/components/ui/ButtonCta';

export const CalculatorCTA: React.FC = () => {
  return (
    <div className="mt-16 bg-gradient-to-r from-neutral-900 to-neutral-800 rounded-lg p-8 lg:p-12">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
          Ready to model your specific market with someone who's built these systems?
        </h2>

        <p className="text-lg text-neutral-200 mb-8 leading-relaxed">
          We can run your exact numbers together - your market, your average loan amount, your current situation. Not generic projections, but a realistic roadmap for your specific business.
        </p>

        {/* CTA Box */}
        <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
          <ButtonCta
            href="/mortgage-lead-generation-demo"
            variant="primary"
            showArrow={true}
            className="w-full sm:w-auto mb-3 text-base sm:text-lg text-center"
          >
            Schedule Your Strategy Session
          </ButtonCta>

          <p className="text-sm text-neutral-300">
            Let's build your roadmap together
          </p>
        </div>

        <p className="text-sm text-neutral-300 mt-6">
          Prefer to read first?{' '}
          <a
            href="/guide/mortgage-marketing-strategies"
            className="text-white font-semibold underline hover:text-neutral-200"
          >
            Read the complete mortgage marketing strategies playbook
          </a>
          .
        </p>
      </div>
    </div>
  );
};
